<script lang="ts">
    import type { IconAnimated } from "@components/material/Icon.module"
    import Icon from "@components/material/Icon.svelte"
    import { twMerge } from "tailwind-merge"
    let icon : IconAnimated
    let className = ""
    export { className as class }
</script>
<Icon {icon} class={twMerge("w-4 h-4 opacity-50", className)} {...$$restProps} />